import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Leaf, GraduationCap, HeartPulse, Cpu, Users, Crown } from "lucide-react";
import api from "@/lib/api";

const ICONS = { Climate: Leaf, Education: GraduationCap, Healthcare: HeartPulse, Technology: Cpu, "Youth Empowerment": Users, "Women's Leadership": Crown };

export default function Impact() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/candidates", { params: { limit: 100 } }).then((r) => setItems(r.data)).catch(() => {}); }, []);

  const metrics = [
    { label: "Impact Initiatives", value: items.length },
    { label: "Communities Reached", value: "1.2M+" },
    { label: "Advocacy Areas", value: 6 },
    { label: "Delegations Engaged", value: "54" },
  ];

  return (
    <div className="section py-12 sm:py-16" data-testid="impact-page">
      <p className="kicker mb-2">Beyond the Crown</p>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl text-amber-50">Africa Impact Dashboard</h1>
      <p className="mt-3 max-w-2xl text-amber-100/60">Every candidate leads a verified social-impact initiative. Together, they are reshaping the continent.</p>

      <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4">
        {metrics.map((m) => (
          <div key={m.label} className="card-lux p-6 text-center">
            <p className="font-mono text-3xl gold-text tabular-nums">{typeof m.value === "number" ? m.value.toLocaleString() : m.value}</p>
            <p className="mt-1 text-xs uppercase tracking-wider text-muted-foreground">{m.label}</p>
          </div>
        ))}
      </div>

      <p className="kicker mb-6 mt-14">Candidate Initiatives</p>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((c) => {
          const Icon = ICONS[c.advocacy] || Users;
          return (
            <Link key={c.id} to={`/candidates/${c.slug}`} className="card-lux p-6">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-emerald-accent/15 text-emerald-accent"><Icon className="h-5 w-5" /></span>
                <div><p className="text-sm text-amber-50">{c.name} {c.flag}</p><p className="text-xs text-gold">{c.advocacy}</p></div>
              </div>
              <p className="mt-4 text-sm text-amber-100/60 line-clamp-3">{c.bio}</p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
